module.exports = __webpack_public_path__ + "assets/img/Clementi Forest.de7357e1.jpg";